import { Link } from 'react-router-dom';
import { organisation } from '../../data/mockData';
import Logo from './Logo';

const columns = [
  {
    title: 'Training',
    links: [
      { label: 'Learnerships', to: '/learnerships' },
      { label: 'Short programmes', to: '/short-programmes' },
      { label: 'How to apply', to: '/apply' },
      { label: 'Corporate training', to: '/contact' },
    ],
  },
  {
    title: 'Qualifications',
    links: [
      { label: 'IT Technical Support', to: '/learnerships#78964' },
      { label: 'IT Systems Development', to: '/learnerships#78965' },
      { label: 'IT Systems Support', to: '/learnerships#48573' },
      { label: 'End User Computing', to: '/learnerships#61591' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About us', to: '/about' },
      { label: 'Contact', to: '/contact' },
      { label: 'Sign in', to: '/login' },
      { label: 'Create account', to: '/register' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-brand-950 text-white">
      <div className="container py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="max-w-sm">
            <Logo variant="light" />
            <p className="mt-5 text-sm leading-relaxed text-white/60">
              MICT SETA accredited IT training and digital solutions. We equip
              learners and businesses with the skills to succeed in the tech
              world.
            </p>

            <dl className="mt-6 space-y-2 text-sm">
              <div className="flex gap-2">
                <dt className="text-white/40">Applications</dt>
                <dd>
                  <a
                    href={`mailto:${organisation.trainingEmail}`}
                    className="text-white/80 hover:text-white"
                  >
                    {organisation.trainingEmail}
                  </a>
                </dd>
              </div>
              <div className="flex gap-2">
                <dt className="text-white/40">Enquiries</dt>
                <dd>
                  <a
                    href={`mailto:${organisation.generalEmail}`}
                    className="text-white/80 hover:text-white"
                  >
                    {organisation.generalEmail}
                  </a>
                </dd>
              </div>
              <div className="flex gap-2">
                <dt className="text-white/40">Phone</dt>
                <dd>
                  <a
                    href={`tel:${organisation.phoneDial}`}
                    className="text-white/80 hover:text-white"
                  >
                    {organisation.phoneDisplay}
                  </a>
                </dd>
              </div>
              <div className="flex gap-2">
                <dt className="text-white/40">Location</dt>
                <dd className="text-white/80">{organisation.location}</dd>
              </div>
            </dl>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-bold uppercase tracking-wider text-white">
                {col.title}
              </h3>
              <ul className="mt-5 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-white/60 hover:text-white"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-white/50">
            &copy; {new Date().getFullYear()} {organisation.name}. All rights
            reserved.
          </p>
          <p className="text-sm text-white/50">
            {organisation.accreditationBody} accredited &middot;{' '}
            {organisation.accreditationNumber}
          </p>
        </div>
      </div>
    </footer>
  );
}
